import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import SmartCheckbox from '../../../shared/components/SmartCheckbox';

const ChatSearch = (props) => {
  const { t, onFilterChange, filterValue, onCheckboxChange, checked } = props;

  return (
    <div className="chat__search_wrapper">
      <div className="chat__search">
        <input
          className="chat__search-input"
          placeholder={t('general.placeholders.search')}
          value={filterValue}
          onChange={(e) => onFilterChange(e)}
        />
        <MagnifyIcon />
      </div>
      <SmartCheckbox
        checked={checked}
        className="chat__search-checkbox"
        onChange={onCheckboxChange}
        tooltip={t('general.only-unread')}
      />
    </div>
  );
};

ChatSearch.propTypes = {
  t: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  filterValue: PropTypes.string,
  checked: PropTypes.bool,
};

ChatSearch.defaultProps = {
  filterValue: '',
  checked: false,
};

export default withTranslation('common')(ChatSearch);
